import { useLayoutEffect } from "react";
export const useOnScrollEffect = (anchorEl, onScroll) => {
    useLayoutEffect(() => {
        if (anchorEl === null) {
            return undefined;
        }
        let parentEl = anchorEl.parentElement;
        const scrollableParents = [];
        while (parentEl !== null) {
            if (parentEl.scrollHeight > parentEl.clientHeight) {
                scrollableParents.push(parentEl);
            }
            parentEl = parentEl.parentElement;
        }
        scrollableParents.forEach((parent) => {
            parent.addEventListener("scroll", onScroll);
        });
        window.addEventListener("scroll", onScroll);
        return () => {
            scrollableParents.forEach((parent) => {
                parent.removeEventListener("scroll", onScroll);
            });
            window.removeEventListener("scroll", onScroll);
        };
    }, [onScroll, anchorEl]);
};
export const useOnResizeParentEffect = (element, onResize) => {
    useLayoutEffect(() => {
        if (element === null) {
            return undefined;
        }
        let parentEl = element.parentElement;
        const observer = new window.ResizeObserver(onResize);
        while (parentEl !== null) {
            observer.observe(parentEl);
            parentEl = parentEl.parentElement;
        }
        return () => observer.disconnect();
    }, [onResize, element]);
};
export const useOnResizeEffect = (element, onResize) => {
    useLayoutEffect(() => {
        if (element === null) {
            return undefined;
        }
        const observer = new window.ResizeObserver(onResize);
        observer.observe(element);
        return () => observer.disconnect();
    }, [onResize, element]);
};
export const anchorPosition = (anchorEl, popOverContainerEl, { horizontalPosition = "left", horizontalAlignment = "left", verticalPosition = "bottom", verticalAlignment = "top", }) => {
    const anchorBBox = anchorEl.getBoundingClientRect();
    const { top, left, bottom, right, width, height } = anchorBBox;
    if (width === 0 && height === 0) {
        return;
    }
    const anchorHPos = { left, right, center: (left + right) / 2 };
    const anchorVPos = { top, bottom, center: (top + bottom) / 2 };
    const popOverBBox = popOverContainerEl.getBoundingClientRect();
    const popOverHOffset = {
        left: 0,
        right: -popOverBBox.width,
        center: -popOverBBox.width / 2,
    };
    const popOverVOffset = {
        top: 0,
        bottom: -popOverBBox.height,
        center: -popOverBBox.height / 2,
    };
    let popOverLeft = anchorHPos[horizontalPosition] + popOverHOffset[horizontalAlignment];
    let popOverTop = anchorVPos[verticalPosition] + popOverVOffset[verticalAlignment];
    const { clientHeight, clientWidth } = document.documentElement;
    const popOverVOverflow = clientHeight - (popOverTop + popOverBBox.height);
    const popOverHOverflow = clientWidth - (popOverLeft + popOverBBox.width);
    if (popOverVOverflow < 0) {
        popOverTop = popOverTop + popOverVOverflow;
    }
    if (popOverHOverflow < 0) {
        popOverLeft = popOverLeft + popOverHOverflow;
    }
    popOverContainerEl.style.top = `${popOverTop}px`;
    popOverContainerEl.style.left = `${popOverLeft}px`;
};
//# sourceMappingURL=popOver.js.map